import walletAddressAtom from './walletAddressAtom';
import rpcProviderAtom from '../rpcProviderAtom';
import { createAsyncAtom } from '../../lib/state';

const walletStarknetDomainAtom = createAsyncAtom(async get => {
  const walletAddress = await get(walletAddressAtom);
  if (!walletAddress) {
    return null;
  }

  try {
    const provider = await get(rpcProviderAtom);
    const starkName = await provider.getStarkName(walletAddress);

    return starkName ?? null;
  } catch (e) {
    // getStarkName throws when no domain is found for the address — this is expected
    if (e instanceof Error && (e.message === 'Starkname not found' || e.message === 'Could not get stark name')) {
      return null;
    }

    console.error('Failed to get starknet domain', e);

    return null;
  }
});

export default walletStarknetDomainAtom;
